import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeOriginFR: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 16"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M9.06612 2.93123C9.10962 3.28242 9.97948 9.1648 9.97948 9.1648L6.71748 9.47209L5.84761 3.45801L9.06612 2.93123Z"
        fill="white"
      />
      <path
        d="M6.0651 3.19467C6.10859 3.54585 6.97846 9.42824 6.97846 9.42824L3.71646 9.73553L2.84659 3.72145L6.0651 3.19467Z"
        fill="#2E50A2"
      />
      <path
        d="M12.2846 2.14109C12.3281 2.49228 13.198 8.37467 13.198 8.37467L9.936 8.68195L9.06613 2.66787L12.2846 2.14109Z"
        fill="#EA3223"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3.48596L12.5389 2L13.5 8.61434L3.46107 10.1003L2.5 3.48596ZM3.20502 4.01553L3.98575 9.38872L12.795 8.08477L12.0143 2.71158L3.20502 4.01553Z"
        fill="#050505"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.80017 3.49912C2.96985 3.47324 3.12819 3.59109 3.15383 3.76235L4.6326 13.6395C4.65824 13.8107 4.54148 13.9706 4.3718 13.9964C4.20212 14.0223 4.04378 13.9045 4.01814 13.7332L2.53937 3.85607C2.51373 3.68481 2.63049 3.525 2.80017 3.49912Z"
        fill="#050505"
      />
    </svg>
  );
};

export default BadgeOriginFR;
